import * as TechniciansAssignment from './techniciansAssignment';
import * as StockDownload from './stockDownload';
import * as TimeMarked from './timeMarked';
import * as Invoicing from './invoicing';
import * as Kanban from './kanban';
import * as Orders from './orders';

const Actions = {
  ...Invoicing,
  ...Kanban,
  ...Orders,
  ...StockDownload,
  ...TechniciansAssignment,
  ...TimeMarked,
};

export default Actions;
